import React from "react";
import BathtubIcon from "@mui/icons-material/Bathtub";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Col, Row } from "react-bootstrap";
import {
  ItemCarritoSpa,
} from "../../../services/carritoServicios";
import { formatearFechaStr } from "../../../utils/dateUtils";
import { InfoRow } from "../../organisms/InfoRow";
import CurrencyFormat from "react-currency-format";
import { PrettyHorarioSpa } from "../../../services/agendamientosSpaServicios";
import { parseCurrency } from "../../../utils/numberUtils";
import { SpaHandlers } from "./Model";
import { IconContainer } from "./organisms/IconContainer";
import DangerIconContainer from "../../organisms/DangerIconContainer";

export const ItemSpa = ({
  item,
  handlers,
  onEliminarItemClick,
}: {
  item: ItemCarritoSpa;
  handlers: SpaHandlers;
  onEliminarItemClick: () => void;
}) => {
  const onPrecioFinalTarifaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTarifaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };
  return (
    <>
      <h4 className="mb-2">
        <div className="d-flex justify-content-between">
          <div>
            <IconContainer>
              <BathtubIcon />
            </IconContainer>
            Reserva de Spa
          </div>
          <div>
            <DangerIconContainer
              style={{ cursor: "pointer" }}
              onClick={onEliminarItemClick}
            >
              <DeleteIcon />
            </DangerIconContainer>
          </div>
        </div>
      </h4>
      <section className="mb-4">
        {item.fechasProgramadas.length > 1 && (
          <div>
            <label className="mb-2" style={{ fontWeight: 500 }}>
              Fechas programadas:
            </label>
            <ul>
              {item.fechasProgramadas.map((fecha) => (
                <li key={fecha}>{formatearFechaStr(fecha)}</li>
              ))}
            </ul>
          </div>
        )}

        {item.fechasProgramadas.length === 1 && (
          <InfoRow
            label="Fecha programada"
            value={formatearFechaStr(item.fechasProgramadas[0])}
          />
        )}

        <>
          <InfoRow label="Horario" value={PrettyHorarioSpa[item.horario]} />
        </>
      </section>
      <section className="mb-4">
        <h5 className="mb-2" style={{ fontWeight: 500 }}>
          <IconContainer>
            <MenuBookIcon />
          </IconContainer>
          Tarifas y planes
        </h5>
        <Row className="mb-2">
          <Col className="col-4" style={{ fontWeight: 500 }}>
            {item.tarifa.nombre + ":"}
          </Col>
          <Col>
            {item.fechasProgramadas.length +
              (item.fechasProgramadas.length === 1
                ? " sesión x "
                : " sesiones x")}
          </Col>
          <Col className="text-right">
            <CurrencyFormat
              className="w-100"
              name="precioFinalTarifaSpa"
              value={item.precioFinal}
              thousandSeparator={","}
              onChange={onPrecioFinalTarifaInputChange}
              prefix={"$"}
              decimalSeparator={"."}
            />
          </Col>
        </Row>
      </section>
    </>
  );
};
